var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _vm.isMask ? _c("div", { staticClass: "mask" }) : _vm._e(),
      _c("Header", {
        on: { anchorScoll: _vm.scollTop, showMask: _vm.showMask }
      }),
      _vm.videoUrl && _vm.videoUrl.includes("iframe")
        ? _c("div", [
            _c("div", {
              staticClass: "video-iframe",
              domProps: { innerHTML: _vm._s(_vm.videoUrl) }
            })
          ])
        : _vm.videoUrl && !_vm.videoUrl.includes("iframe")
        ? _c(
            "video",
            {
              staticClass: "video",
              attrs: {
                poster: _vm.videoPost,
                autoplay: "",
                loop: "",
                controls: ""
              }
            },
            [
              _c("source", {
                attrs: {
                  src: _vm.videoUrl,
                  type: "video/mp4",
                  alt: "backgroundVideo"
                }
              })
            ]
          )
        : _c("div", { staticClass: "cover" }, [
            _c("img", { attrs: { src: _vm.coverImg, alt: "" } })
          ]),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isMobile,
              expression: "!isMobile"
            }
          ],
          staticClass: "share"
        },
        [
          _c("p", { staticClass: "title" }, [_vm._v("Share this Article")]),
          _c("div", { staticClass: "shareList" }, [
            _c("p", { on: { click: _vm.copy } }, [
              _c("img", {
                attrs: {
                  src: require("@/assets/img/website/copy.png"),
                  alt: ""
                }
              })
            ]),
            _c("a", { attrs: { href: _vm.sharelink_fb } }, [
              _c("img", {
                attrs: {
                  src: require("@/assets/img/website/Facebook.png"),
                  alt: ""
                }
              })
            ]),
            _c("a", { attrs: { href: _vm.sharelink_ins } }, [
              _c("img", {
                attrs: { src: require("@/assets/img/website/ins.png"), alt: "" }
              })
            ]),
            _c("a", { attrs: { href: _vm.sharelink_tw } }, [
              _c("img", {
                attrs: {
                  src: require("@/assets/img/website/twitter.png"),
                  alt: ""
                }
              })
            ]),
            _c("a", { attrs: { href: _vm.sharelink_weibo } }, [
              _c("img", {
                attrs: {
                  src: require("@/assets/img/website/weibo.png"),
                  alt: ""
                }
              })
            ]),
            _c("a", { attrs: { href: _vm.sharelink_line } }, [
              _c("img", {
                attrs: {
                  src: require("@/assets/img/website/round-grey.png"),
                  alt: ""
                }
              })
            ]),
            _c(
              "p",
              { staticClass: "hidden_weixin", on: { click: _vm.openWei } },
              [
                _c("img", {
                  attrs: {
                    src: require("@/assets/img/website/weixin.png"),
                    alt: ""
                  }
                })
              ]
            ),
            _c("div", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isCode,
                  expression: "isCode"
                }
              ],
              ref: "qrcode",
              attrs: { id: "qrcode" }
            })
          ])
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isMobile,
              expression: "isMobile"
            }
          ],
          staticClass: "mbShare"
        },
        [
          _c(
            "div",
            { staticClass: "shareIcon", on: { click: _vm.openShare } },
            [
              _c("img", {
                attrs: {
                  src: require("@/assets/img/website/mb-share.png"),
                  alt: ""
                }
              })
            ]
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isShare,
                  expression: "isShare"
                }
              ],
              staticClass: "mb-shareList"
            },
            [
              _c("p", { on: { click: _vm.copy } }, [
                _c("img", {
                  attrs: {
                    src: require("@/assets/img/website/mb-copy.png"),
                    alt: ""
                  }
                })
              ]),
              _c("a", { attrs: { href: _vm.sharelink_fb } }, [
                _c("img", {
                  attrs: {
                    src: require("@/assets/img/website/mb-facebook.png"),
                    alt: ""
                  }
                })
              ]),
              _c("a", { attrs: { href: _vm.sharelink_ins } }, [
                _c("img", {
                  attrs: {
                    src: require("@/assets/img/website/mb-ins.png"),
                    alt: ""
                  }
                })
              ]),
              _c("a", { attrs: { href: _vm.sharelink_tw } }, [
                _c("img", {
                  attrs: {
                    src: require("@/assets/img/website/mb-twitter.png"),
                    alt: ""
                  }
                })
              ]),
              _c("a", { attrs: { href: _vm.sharelink_weibo } }, [
                _c("img", {
                  attrs: {
                    src: require("@/assets/img/website/mb-weibo.png"),
                    alt: ""
                  }
                })
              ]),
              _c("a", { attrs: { href: _vm.sharelink_line } }, [
                _c("img", {
                  attrs: {
                    src: require("@/assets/img/website/round-grey.png"),
                    alt: ""
                  }
                })
              ]),
              _c(
                "p",
                {
                  staticClass: "hidden_weixin",
                  on: { click: _vm.nativeShareCall }
                },
                [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/img/website/mb-weixin.png"),
                      alt: ""
                    }
                  })
                ]
              ),
              _c("div", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isCode,
                    expression: "isCode"
                  }
                ],
                ref: "qrcode",
                staticClass: "mbQrcode",
                attrs: { id: "qrcode" }
              })
            ]
          )
        ]
      ),
      _c("div", { staticClass: "detail" }, [
        _c("div", { staticClass: "teads_here1" }),
        _c("div", { staticClass: "title" }, [_vm._v(_vm._s(_vm.title))]),
        _c(
          "div",
          { staticClass: "labelBox" },
          _vm._l(_vm.label, function(val, index) {
            return _c(
              "a",
              {
                key: index,
                staticClass: "newsLabel",
                attrs: { href: "/list/tag/" + val.toLowerCase() }
              },
              [_vm._v("#" + _vm._s(val))]
            )
          }),
          0
        ),
        _c("div", { staticClass: "date" }, [_vm._v(_vm._s(_vm.date))]),
        _vm.textVal.length != 0
          ? _c(
              "div",
              _vm._l(_vm.textVal, function(item, index) {
                return _c("div", { key: index }, [
                  _c("div", {
                    ref: "content",
                    refInFor: true,
                    staticClass: "content",
                    domProps: { innerHTML: _vm._s(item) }
                  }),
                  _vm.sliderImg.length != 0
                    ? _c(
                        "div",
                        { staticClass: "bannerBox" },
                        [
                          _c(
                            "aCarousel",
                            { attrs: { arrows: "" } },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "custom-slick-arrow",
                                  attrs: { slot: "prevArrow" },
                                  slot: "prevArrow"
                                },
                                [
                                  !_vm.isMobile
                                    ? _c("img", {
                                        attrs: {
                                          src: require("@/assets/img/website/detailLt.png"),
                                          alt: ""
                                        }
                                      })
                                    : _c("img", {
                                        attrs: {
                                          src: require("@/assets/img/website/mbDetailLeft.png"),
                                          alt: ""
                                        }
                                      })
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "custom-slick-arrow",
                                  attrs: { slot: "nextArrow" },
                                  slot: "nextArrow"
                                },
                                [
                                  !_vm.isMobile
                                    ? _c("img", {
                                        attrs: {
                                          src: require("@/assets/img/website/detailRt.png"),
                                          alt: ""
                                        }
                                      })
                                    : _c("img", {
                                        attrs: {
                                          src: require("@/assets/img/website/mbDetailRight.png"),
                                          alt: ""
                                        }
                                      })
                                ]
                              ),
                              _vm._l(_vm.sliderImg[index], function(
                                item,
                                index
                              ) {
                                return _c(
                                  "div",
                                  { key: index, staticClass: "banner" },
                                  [_c("img", { attrs: { src: item, alt: "" } })]
                                )
                              })
                            ],
                            2
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ])
              }),
              0
            )
          : _c("div", {
              ref: "content",
              staticClass: "content",
              domProps: { innerHTML: _vm._s(_vm.content) }
            }),
        _c("div", { staticClass: "teads_here2" })
      ]),
      _c("Footer", {
        attrs: { isMobile: _vm.isMobile },
        on: { pageTop: _vm.pageTop, nativeShareCall: _vm.nativeShareCall }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js?{"compilerOptions":{"preserveWhitespace":false},"extractCSS":true}!./node_modules/vue-loader/lib?{"compilerOptions":{"preserveWhitespace":false},"extractCSS":true}!./src/views/Detail.vue?vue&type=template&id=40f4caea&scoped=true&
// module id = 415
// module chunks = 1